import React, {useEffect, useReducer} from 'react';
import styled from 'styled-components';
import {
  reducer,
  initialState,
  actionSelectTab,
  actionUpdateSelectedFilters,
  actionUpdateDeviceData,
} from '../features/Inventories/reducer/InventoryReducer';
import Layout from './Layout';
import LayoutHeader, {LayoutHeaderIconTypes} from 'components/LayoutHeader';
import Container from 'components/Container';
import Grid from '@material-ui/core/Grid';
import Inventories, {useParamsInventory, useInventories} from 'features/Inventories';
import useSiteInfo from 'components/SiteIDSearch/hooks/useSiteInfo';
import HeaderTabs from 'features/Inventories/components/HeaderTabs';

const StyledLayout = styled(Layout)`
  .header-root {
    margin-bottom: 24px;
  }
  @media (min-width: 600px) {
    .header-root {
      margin-bottom: 24px;
    }
  }
`;

function Inventory() {
  const [state, dispatch] = useReducer(reducer, initialState);
  const {sites, isSiteStoreMerged} = useSiteInfo();
  const {data, pending} = useInventories();

  const {
    tab,
    handleFilterChange,
    handleClearFilters,
    handleTabChange,
    geo,
    brand,
    siteType,
    storeConcept,
    siteStatus,
    deviceType,
    nvsnso,
  } = useParamsInventory();

  useEffect(() => {
    dispatch(actionSelectTab(tab));
  }, [tab]);

  useEffect(() => {
    dispatch(
      actionUpdateSelectedFilters({
        geo,
        brand,
        siteType,
        storeConcept,
        siteStatus,
        deviceType,
        nvsnso,
      })
    );
  }, [geo, brand, siteType, storeConcept, siteStatus, deviceType, nvsnso]);

  useEffect(() => {
    if (data !== null && !pending && isSiteStoreMerged) {
      dispatch(actionUpdateDeviceData(data, sites));
    }
  }, [data, pending, sites, isSiteStoreMerged]);

  return (
    <StyledLayout
      headerContent={
        <>
          <LayoutHeader title={'Device Inventory'} icon={LayoutHeaderIconTypes.Inventory} />
          <HeaderTabs selectedTab={tab} handleTabChange={handleTabChange} />
        </>
      }
    >
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Inventories
              isPending={!state.isDeviceDataReady}
              handleFilterChange={handleFilterChange}
              handleClearFilters={handleClearFilters}
              selectedTab={tab}
              invState={state}
            />
          </Grid>
        </Grid>
      </Container>
    </StyledLayout>
  );
}

export default Inventory;
